<template>
  <div>
    <v-container class="content-wrapper" fluid id="statistics-tab">
      <!-- Hosting Institutions,  Provider &  Services buttons -->
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" md="6" class="justify-center d-flex flex-wrap">
          <v-btn-toggle
            v-model="toggleButton"
            rounded
            mandatory
            class="d-flex flex-wrap justify-center"
          >
            <v-btn value="hostingInstitutions" class="btn-selected">
              Hosting Institutions
            </v-btn>
            <v-btn value="provider" class="btn-selected">
              Provider
            </v-btn>
            <v-btn value="services" class="btn-selected">
              Services
            </v-btn>
            <v-btn value="equipment" class="btn-selected">
              Equipment
            </v-btn>
            <v-btn value="patents" class="btn-selected">
              Patents
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Hosting Institutions -->
      <v-row v-if="toggleButton === 'hostingInstitutions'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Hosting Institutions
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleButton === 'hostingInstitutions'" :key="0">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <table-statistics
              ref="table"
              :url-api="'/api/v1/providers/views-per-institution'"
              :search="searchInstitution"
              :search-attributes="['text']"
              :key="tableKey"
            >
            </table-statistics>
          </v-card>
        </v-col>
      </v-row>

      <!-- Provider -->
      <v-row v-if="toggleButton === 'provider'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Provider
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleButton === 'provider'" :key="1">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <table-statistics
              ref="table"
              :url-api="'/api/v1/providers/views'"
              :search="searchProvider"
              :search-attributes="['text']"
              :key="tableKey"
            >
            </table-statistics>
          </v-card>
        </v-col>
      </v-row>

      <!-- Services -->
      <v-row v-if="toggleButton === 'services'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Services
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleButton === 'services'" :key="2">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <table-statistics
              ref="table"
              :url-api="'/api/v1/resources/views'"
              :search="searchService"
              :search-attributes="['text']"
              :key="tableKey"
            >
            </table-statistics>
          </v-card>
        </v-col>
      </v-row>

      <!-- Equipment -->
      <v-row v-if="toggleButton === 'equipment'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Equipment
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleButton === 'equipment'" :key="3">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <table-statistics
              ref="table"
              :url-api="'/api/v1/equipment/views'"
              :search="searchEquipment"
              :search-attributes="['text']"
              :key="tableKey"
            >
            </table-statistics>
          </v-card>
        </v-col>
      </v-row>

      <!-- Patents -->
      <v-row v-if="toggleButton === 'patents'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Patents
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleButton === 'patents'" :key="4">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <table-statistics
              ref="table"
              :url-api="'/api/v1/patent/views'"
              :search="searchPatent"
              :search-attributes="['text']"
              :key="tableKey"
            >
            </table-statistics>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import TableStatistics from '@/components/admin/statistics/TableStatistics';

export default {
  name: 'Statistics',
  mixins: [util],
  components: { TableStatistics },

  data: () => ({
    tableKey: 0,
    toggleButton: 'hostingInstitutions',
    searchInstitution: {},
    searchProvider: {},
    searchService: {},
    searchEquipment: {},
    searchPatent: {},
  }),
};
</script>

<style scoped>
.btn-selected {
  font-weight: bold;
}
</style>
